import { clickOpenText, getNumericValue } from "../../common/constants/variables/globalVariables";
import { ValidateFields } from "../../modules/form/ValidateFields";
import { dataCalculator } from "../form/setValueForm";
import { GalleryTypology } from "./GalleryTypology";
import { recommend } from "./Recommend";
import { Slider } from "../../common/services/sliderService";
import { adjustColor } from "../../../../../../../modules/custom/ev_results/js/components/results-load/results-ui";
class Typology {
    constructor(formState) {
        this.formState = formState;
        this.typologyApiUrl = '/api/ev-lead';
        this.nameCalculator = '';
        this.typologyFieldsCount = 6;
        this.headerOffset = 290;
        this.validateForm = new ValidateFields(formState);
        this.slider = new GalleryTypology();
        this.showForm = this.showForm.bind(this);
        this.showAllFeatures = this.showAllFeatures.bind(this);
    }
    /**
     * Initializes and manages settings and behaviors for the typology page.
     * @returns {void}
     */
    loadTypology() {
        const formSettings = this.getFormSettings();
        this.formState.manageState('formName', formSettings.formName); // Set the form modal ID       
        this.clearSessionStorage();
        this.updateDeliveryMonth();
        this.initializeSliderAndTabs();
        this.setupWindowResizeListener();
        this.setupScrollListener();
        this.initializeReadMore();
        this.loadMontlyQuoteTypology();
        recommend.loadRecommend();
        this.initGalleryWithThumbs();
        this.loadBannerBuilder();
    }
    /**
     * Returns form settings based on screen width.
     * @returns {Object} - The form settings.
     */
    getFormSettings() {
        if (screen.width < 1000) {
            return {
                formName: '#typologyFormMobile'
            };
        }
        return {
            formName: '#typologyForm'
        };
    }
    /**
     * Clears specific session storage items.
     */
    clearSessionStorage() {
        ['contactFormSent', 'popupFormSent', 'showPopup'].forEach(item => {
            window.sessionStorage.removeItem(item);
        });
    }
    /**
     * Updates the delivery month based on the data attribute.
     */
    updateDeliveryMonth() {
        const fechaEntregaElement = document.getElementById('deliveryDate');
        const monthValueElement = document.getElementById("deliveryMonth");
        if (fechaEntregaElement && monthValueElement) {
            const month = parseInt(fechaEntregaElement.getAttribute("data-month-value") || '0');
            const quarter = this.getQuarter(month);
            monthValueElement.innerHTML = quarter;
        }
    }
    /**
     * Returns the quarter based on the month.
     * @param {number} month - The month value.
     * @returns {string} - The quarter.
     */
    getQuarter(month) {
        if (month <= 3)
            return '1T';
        if (month <= 6)
            return '2T';
        if (month <= 9)
            return '3T';
        return '4T';
    }
    /**
     * Initializes the slider and tab functionality.
     */
    initializeSliderAndTabs() {
        if (document.querySelector('.typology-top')) {
            this.setupTabNavigation();
        }
    }
    /**
     * Initializes all read more info buttons in node--typology
     */
    initializeReadMore() {
        const btns = Array.from(document.getElementsByClassName('js-hide-action'));
        btns.forEach(btn => btn.addEventListener('click', clickOpenText));
    }
    /**
     * Sets up the tab navigation functionality.
     */
    setupTabNavigation() {
        const tabs = Array.from(document.querySelectorAll('.ev-tabs-column__item'));
        if (window.innerWidth <= 500) {
            this.scrollTabs(tabs);
        }
        this.styleSectionHeaders();
        this.setupTabScroll(tabs);
    }
    /**
     * Scrolls the tabs based on the selected item.
     * @param {HTMLElement[]} tabs - The tab elements.
     */
    scrollTabs(tabs) {
        let totalTranslate = 0;
        let scrollX = 0;
        tabs.forEach(tab => {
            totalTranslate += tab.offsetWidth;
            if (tab.classList.contains('active')) {
                scrollX = tab.getBoundingClientRect().left;
            }
        });
    }
    /**
     * Styles the section headers for better display.
     */
    styleSectionHeaders() {
        const sections = [
            { selector: '#estadisticasSector h2', classes: ['my-4'] },
            { selector: '#preguntasFrecuentes h2', classes: ['mt-3', 'pt-4', 'border-top', 'mb-4'] },
            { selector: '#contentSection h2', classes: ['my-5'], additionalStyles: { selector: '#contentSection', additionalClasses: ['mt-3', 'pt-5', 'border-top', 'mb-3'] } }
        ];
        sections.forEach(section => {
            const element = document.querySelector(section.selector);
            if (element) {
                element.classList.remove('d-none');
                section.classes.forEach(cls => element.classList.add(cls));
                if (section.additionalStyles) {
                    const additionalElement = document.querySelector(section.additionalStyles.selector);
                    additionalElement === null || additionalElement === void 0 ? void 0 : additionalElement.classList.add(...section.additionalStyles.additionalClasses);
                }
            }
        });
        const typologyFixedCaption = document.getElementById('typologyFixedCaption');
        typologyFixedCaption === null || typologyFixedCaption === void 0 ? void 0 : typologyFixedCaption.classList.remove('d-none');
    }
    /**
     * Sets up the tab scroll behavior.
     * @param {HTMLElement[]} tabs - The tab elements.
     */
    setupTabScroll(tabs) {
        const map = new Map(); // section -> tab
        const sections = [];
        tabs.forEach(tab => {
            const href = tab.getAttribute('href');
            if (href && href.startsWith('#')) {
                const sec = document.querySelector(href);
                if (sec) {
                    map.set(sec, tab);
                    sections.push(sec);
                }
            }
        });
        const activate = (tab) => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
        };
        // rootMargin: compensamos header y evitamos activación demasiado temprana/tardía
        const observer = new IntersectionObserver((entries) => {
            // Elegimos la entrada más “dominante” (ratio más alto y top más cercano al header)
            const visibles = entries
                .filter(e => e.isIntersecting)
                .sort((a, b) => {
                const r = b.intersectionRatio - a.intersectionRatio;
                return r !== 0 ? r : Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top);
            });
            if (visibles.length > 0) {
                const section = visibles[0].target;
                const tab = map.get(section);
                if (tab)
                    activate(tab);
            }
        }, {
            root: null,
            // Empuja la “línea de activación” hacia abajo para cubrir el header
            rootMargin: `-${this.headerOffset}px 0px -60% 0px`,
            threshold: [0, 0.25, 0.5, 0.75, 1],
        });
        sections.forEach(sec => observer.observe(sec));
    }
    /**
     * Sets up the window resize listener.
     */
    setupWindowResizeListener() {
        window.addEventListener("resize", () => {
            this.changeIDWindowSize();
        });
        this.changeIDWindowSize();
        this.showBlueprint();
        if (window.innerWidth > 768) {
            this.activateZoomImg();
        }
    }
    /**
     * Sets up the scroll listener to show popup and handle form visibility.
     */
    setupScrollListener() {
        let overScroll = false;
        window.addEventListener("scroll", () => {
            if (window.innerWidth < 1000) {
                this.toggleContactFormPosition();
            }
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollPercent = scrollTop / docHeight;
            overScroll = scrollPercent >= 0.5;
            window.sessionStorage.setItem("showPopup", overScroll.toString());
            window.sessionStorage.setItem("modalShown", "false");
        });
    }
    /**
     * Toggles the contact form position based on scroll.
     */
    toggleContactFormPosition() {
        var _a;
        const contactDesktop = document.getElementById('contact-desktok');
        const rect = (_a = document.querySelector(`.js-contact-mobile #typologyForm`)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (rect && rect.top < 500) {
            contactDesktop.style.bottom = "-100px";
        }
        else {
            contactDesktop.style.bottom = "0";
        }
        if (rect && rect.top < 45) {
            contactDesktop.style.bottom = "0";
        }
    }
    /**
     * Displays the map in the corresponding container and hides the map image.
     * @returns {void}
     */
    showMap() {
        var _a, _b;
        (_a = document.getElementById('mapImg')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
        (_b = document.querySelector('#mapRender #map')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    /**
     * Displays a form typology based on the form type and the user's selection.
     * @param {string} type - The type of form to display, such as 'contact', 'simulator', 'simulator-subsidy', etc.
     * @returns {void}
     */
    showForm(type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const formName = this.formState.manageState('formName');
        const form = document.querySelector(formName);
        const confirmationContainer = form.querySelector('.js-confirmation-mess');
        const loaderContainer = form.querySelector('#load-send-form');
        const formContainer = form.querySelector('#fields-form');
        this.formState.manageState('resultsCalculator', '#calculusModal');
        let mortgageFields = form === null || form === void 0 ? void 0 : form.querySelectorAll('.mortgage-input, .mortgage-input input, .mortgage-label');
        let contactFormFields = form === null || form === void 0 ? void 0 : form.querySelectorAll('.input-form:not(.subsidy-input):not(.mortgage-input), .contact-field');
        const hideFields = (fields) => fields.forEach(field => field.classList.add('d-none'));
        const showFields = (fields) => fields.forEach(field => field.classList.remove('d-none'));
        const resetHeader = (showSimulator) => {
            if (showSimulator) {
                document.querySelectorAll('#headerContact').forEach(element => {
                    element.classList.remove('d-none');
                });
                document.querySelectorAll('#headerSimulator').forEach(element => {
                    element.classList.add('d-none');
                });
            }
            else {
                document.querySelectorAll('#headerContact').forEach(element => {
                    element.classList.add('d-none');
                });
                document.querySelectorAll('#headerSimulator').forEach(element => {
                    element.classList.remove('d-none');
                });
            }
        };
        hideFields(mortgageFields);
        hideFields(contactFormFields);
        confirmationContainer === null || confirmationContainer === void 0 ? void 0 : confirmationContainer.classList.remove('d-flex');
        loaderContainer === null || loaderContainer === void 0 ? void 0 : loaderContainer.classList.remove('d-flex');
        formContainer === null || formContainer === void 0 ? void 0 : formContainer.classList.remove('d-none');
        form === null || form === void 0 ? void 0 : form.classList.remove('d-none');
        if (type.includes('simulator')) {
            (_a = document.querySelector('.typology-contact__form.form_contac.form_contac--typology')) === null || _a === void 0 ? void 0 : _a.classList.add('simulator-border');
            if (type === 'simulator' || type === 'simulator-mortgage' || type === 'simulator-subsidy') {
                resetHeader(true);
                (form === null || form === void 0 ? void 0 : form.querySelector('input[name="checkboxForm"]')).checked = false;
                (_b = form === null || form === void 0 ? void 0 : form.querySelector('input[name="checkboxForm"]')) === null || _b === void 0 ? void 0 : _b.classList.remove('valid');
                (form === null || form === void 0 ? void 0 : form.querySelector('.btn-form')).disabled = true;
                (_c = form === null || form === void 0 ? void 0 : form.querySelector('.btn-form .sending-message')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
                (_d = form === null || form === void 0 ? void 0 : form.querySelector('.btn-form .js-message')) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
            }
        }
        if (type === 'simulator' && !window.sessionStorage.getItem('contactFormSent')) {
            (_e = document.querySelector('.typology-contact__form__back-action')) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
            this.typologyFieldsCount = 6;
            this.typologyApiUrl = '/api/ev-lead';
            this.nameCalculator = '';
            (_f = document.getElementById('typologyFormOptions')) === null || _f === void 0 ? void 0 : _f.classList.remove('d-none');
            showFields(contactFormFields);
            (_g = document.getElementById('typologyForm')) === null || _g === void 0 ? void 0 : _g.classList.remove('d-none');
        }
        if (type.includes('mortgage')) {
            showFields(mortgageFields);
            resetHeader(false);
            this.nameCalculator = 'Calculadora Hipotecaria';
            this.typologyApiUrl = '/api/v1/calculator';
            document.querySelectorAll('.typology-contact__form__header__title .modal-subtitle').forEach(element => {
                element.textContent = 'Y te brindaremos el valor aproximado de tu Crédito';
            });
            if (type === 'simulator-mortgage') {
                this.typologyFieldsCount = 4;
            }
            if (type === 'full-simulator-mortgage') {
                this.typologyFieldsCount = 9;
                showFields(contactFormFields);
                (_h = document.querySelector('.typology-contact__form__back-action')) === null || _h === void 0 ? void 0 : _h.classList.remove('d-none');
                (_j = document.getElementById('typologyFormOptions')) === null || _j === void 0 ? void 0 : _j.classList.add('d-none');
            }
        }
        if (type.includes('subsidy')) {
            this.typologyFieldsCount = 2;
            const subsidyFields = document.querySelectorAll('.subsidy-input, .subsidy-label');
            showFields(subsidyFields);
            resetHeader(false);
            this.nameCalculator = 'Calculadora de Subsidio';
            this.typologyApiUrl = '/api/v1/calculator';
            document.querySelectorAll('.typology-contact__form__header__title .modal-subtitle').forEach(element => {
                element.textContent = 'Y te brindaremos el valor aproximado de tu Subsidio';
            });
            if (type === 'full-simulator-subsidy') {
                this.typologyFieldsCount = 7;
                showFields(contactFormFields);
                (_k = document.querySelector('.typology-contact__form__back-action')) === null || _k === void 0 ? void 0 : _k.classList.remove('d-none');
                (_l = document.getElementById('typologyFormOptions')) === null || _l === void 0 ? void 0 : _l.classList.add('d-none');
            }
        }
        this.formState.manageState('openCalculator', type);
        this.formState.manageState('valueFields', this.typologyFieldsCount);
        const nameInput = document.querySelector("#typologyForm input[name='name']");
        nameInput === null || nameInput === void 0 ? void 0 : nameInput.focus();
    }
    toggleFeatureVisibility(featuresSelector, buttonId, showItems) {
        const hideFeaturesList = Array.from(document.querySelectorAll(`${featuresSelector} .show-hide-feature.d-none`));
        const showFeaturesList = Array.from(document.querySelectorAll(`${featuresSelector} .show-hide-feature`));
        const button = document.getElementById(buttonId);
        if (hideFeaturesList.length > 0) {
            hideFeaturesList.forEach(element => element.classList.remove('d-none'));
            button.textContent = showItems === 'typologyItems'
                ? "Ocultar características"
                : "Ocultar características del proyecto";
        }
        else {
            showFeaturesList.forEach(element => element.classList.add('d-none'));
            button.textContent = showItems === 'typologyItems'
                ? "Ver todas las características del inmueble"
                : "Ver todas las características del proyecto";
        }
    }
    /**
     * Shows or hides the typology or project characteristics, depending if
     * the contact form or simulator has been sent.
     *
     * @param {string} type - The type of feature list (e.g. 'project' or 'typology').
     * @param {string} buttonId - The id button of features, can be 'jsAllTypologyFeatures' or 'jsAllProjectFeatures'.
     */
    showAllFeatures(type, buttonId) {
        const hideFeaturesList = Array.from(document.querySelectorAll(`#${type} .show-hide-feature.d-none`));
        const button = document.getElementById(buttonId);
        if (hideFeaturesList.length > 0) {
            hideFeaturesList.forEach(element => {
                element.classList.remove('d-none');
            });
        }
        button === null || button === void 0 ? void 0 : button.classList.add('d-none');
    }
    /**
     * Build the link to generate a PDF of the type or project, depending on the API used.
     * @param {number} nodeToPrintId - The ID of the node to be printed.
     * @param {string} apiUrl - The URL of the API to be used to build the link.
     * @returns {string} - The complete link to generate the PDF, with the corresponding parameters.
     */
    buildPDFLink(nodeToPrintId, apiUrl) {
        var _a, _b;
        let baseUrl = `print/pdf/node/${nodeToPrintId}`;
        if (apiUrl == '/api/ev-lead') {
            return baseUrl;
        }
        else {
            let yearsTerm = Number(document.querySelector("#typologyForm select[name='plazo']").value);
            let homePrice = getNumericValue((_a = document.getElementById('price')) === null || _a === void 0 ? void 0 : _a.textContent);
            let downPaymentPercentageValue = Number(document.getElementById('value-cuota-inicial-contact').value.split('%')[0]) / 100;
            let interest = Number((_b = document.getElementById('visPercentage novisPercentage')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-percentage'));
            return `${baseUrl}?yearsTerm=${yearsTerm}&homePrice=${homePrice}&downPaymentPercentageValue=${downPaymentPercentageValue}&interest=${interest}`;
        }
    }
    loadMontlyQuoteTypology() {
        var _a;
        const homePrice = getNumericValue((_a = document.getElementById('price')) === null || _a === void 0 ? void 0 : _a.textContent);
        const typologyType = document.getElementById('value-vis') ? 11660 : 20220;
        const downPaymentPercentage = 30;
        const leasingDownPaymentPercentage = 20;
        const yearsTerm = 20;
        const montlyQuote = dataCalculator.calculateQuote(homePrice, typologyType, downPaymentPercentage, yearsTerm);
        const leasingMonthlyQuote = dataCalculator.calculateQuote(homePrice, typologyType, leasingDownPaymentPercentage, yearsTerm);
        if (document.getElementById('montlyQuote')) {
            document.getElementById('montlyQuote').innerHTML = montlyQuote;
        }
        if (document.getElementById('leasingMonthlyQuote')) {
            document.getElementById('leasingMonthlyQuote').innerHTML = leasingMonthlyQuote;
        }
    }
    changeIDWindowSize() {
        const isMobile = window.innerWidth < 1000;
        const formMobile = document.querySelector(`.js-contact-mobile #typologyFormMobile`);
        const formDesktop = document.querySelector(`.js-contact-desktop #typologyForm`);
        if (isMobile) {
            formMobile === null || formMobile === void 0 ? void 0 : formMobile.setAttribute('id', 'typologyForm');
            formDesktop === null || formDesktop === void 0 ? void 0 : formDesktop.setAttribute('id', 'typologyFormDesktop');
        }
        else {
            formDesktop === null || formDesktop === void 0 ? void 0 : formDesktop.setAttribute('id', 'typologyForm');
            formMobile === null || formMobile === void 0 ? void 0 : formMobile.setAttribute('id', 'typologyFormMobile');
        }
    }
    showBlueprint() {
        const blueprintModal = document.getElementById('blueprintModal');
        blueprintModal === null || blueprintModal === void 0 ? void 0 : blueprintModal.addEventListener('show.bs.modal', event => {
            const trigger = event === null || event === void 0 ? void 0 : event.relatedTarget;
            const imgSrc = trigger.getAttribute('data-blueprint');
            const typologyUrl = trigger.getAttribute('data-typology-url');
            const modalImg = blueprintModal.querySelector('#blueprintModalImg');
            const modalRedirect = blueprintModal.querySelector('#typologyModalUrl');
            modalImg.src = imgSrc || '';
            modalRedirect.href = typologyUrl || '';
        });
    }
    activateZoomImg() {
        const zoomView = document.getElementById('zoomView');
        const zoomContainers = document.querySelectorAll('.js-gallery-images');
        const lens = document.getElementById('lens');
        if (!zoomView || !lens)
            return;
        zoomContainers.forEach((container) => {
            const image = container.querySelector('img');
            container.addEventListener('mousemove', (e) => {
                const rect = container.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                const xPercent = (x / container.offsetWidth) * 100;
                const yPercent = (y / container.offsetHeight) * 100;
                zoomView.style.display = 'block';
                lens.style.display = 'block';
                lens.style.left = `${rect.left + x - 100 / 2}px`;
                lens.style.top = `${rect.top + y - 100 / 2}px`;
                const lensSize = 100;
                lens.style.left = `${rect.left + x - lensSize / 2}px`;
                lens.style.top = `${rect.top + y - lensSize / 2}px`;
                zoomView.style.backgroundImage = `url('${image === null || image === void 0 ? void 0 : image.src}')`;
                zoomView.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
            });
            container.addEventListener('mouseleave', () => {
                zoomView.style.display = 'none';
                lens.style.display = 'none';
            });
        });
    }
    loadBannerBuilder() {
        const bannerBuilderFair = document.querySelector('.fair-typology-banner--builder');
        if (bannerBuilderFair) {
            const baseColor = bannerBuilderFair.getAttribute('base-color');
            if (baseColor) {
                const adjustedColor = adjustColor(baseColor);
                bannerBuilderFair.style.background =
                    `linear-gradient(45deg, ${baseColor} 0%, ${adjustedColor} 100%)`;
            }
        }
    }
    initGalleryWithThumbs() {
        const splideElement = document.getElementById('splideGallery');
        const thumbsElement = document.getElementById('splideThumbnails');
        if (!splideElement || !thumbsElement)
            return;
        Slider.createSynced('#splideGallery', '#splideThumbnails', {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            drag: false,
            breakpoints: {
                768: {
                    perPage: 1,
                },
            },
        }, {
            fixedWidth: 100,
            fixedHeight: 70,
            gap: '10px',
            rewind: true,
            pagination: false,
            arrows: false,
            isNavigation: true,
            focus: 'center',
            cover: true
        });
    }
}
export { Typology };
